<script lang="ts" setup>
defineProps<{
  label: string
  value: string | number
  highlight: boolean
}>()
</script>

<template>
  <div class="flex flex-col text-lg">
    <span class="text-gray-500 text-sm">{{ label }}</span>
    <span :class="{ 'font-bold': highlight }">{{ value }}</span>
  </div>
</template>
